module.exports = __webpack_public_path__ + "img/icon-enkrypt-block.cb05ee30.svg";